export const START_LOADING_FOR_ACTION = "Starte Laden für Aktion";
export const STOP_LOADING_FOR_ACTION = "Stoppe Laden für Aktion";
export const RESET_LOADING_FOR_ACTION = "Resettet alle Loading For Action";
export const SET_LOADING_META_FOR_ACTION = "Setze Loading Meta Eigenschaften";
export const RESET_LOADING_META_FOR_ACTION =
  "Entferne Loading Meta Eigenschaften";
